export default "__VITE_ASSET__c06517a2__"